import React from 'react'
import { OrganizationQuery } from './organization-query'
import { OrganizationSettingsQuery } from './organization-settings-query'
import { OrganizationSettingsMutation } from './organization-settings-mutation'
import {
  CustomMetadataField,
  CustomMetadataRestrictSettings,
  Importance,
  RouteCoveragePolicy
} from './index'
import { MutationFn } from 'react-apollo'
import { Policy } from '../policy'

export interface Props {
  organizationUuid: string
  children: (props: {
    organizationID: string

    numberOfLicensesAvailable: number
    numberOfLicensesUsed: number
    availableRemediationPolicies: Policy[]
    availableCompliancePolicies: Policy[]

    autoLicense: boolean
    filterAppMostRecentSession: boolean
    preventOnboardingFailingApplications: boolean
    preventOnboardingFailingApplicationsBySession: boolean
    protectRuleEnv: string
    routeExpirationDays: number | null
    remediationPolicies: Policy[]
    compliancePolicies: Policy[]
    importance: Importance

    customMetadataFields: CustomMetadataField[]
    customMetadataSettings: CustomMetadataRestrictSettings

    routeCoverageAbsolutePolicy: RouteCoveragePolicy

    updateSettings: MutationFn
  }) => React.ReactNode
}

export function OrganizationApplicationsSettingsRequests({
  children,
  organizationUuid
}: Props) {
  return (
    <OrganizationQuery organizationUuid={organizationUuid}>
      {({ currentOrganization }) => {
        const {
          organizationUuid,
          numberOfLicensesUsed,
          numberOfLicensesAvailable
        } = currentOrganization

        return (
          <OrganizationSettingsQuery organizationID={organizationUuid}>
            {({
              settings: {
                availableCompliancePolicies,
                availableRemediationPolicies,
                autoLicense,
                filterAppMostRecentSession,
                preventOnboardingFailingApplications,
                preventOnboardingFailingApplicationsBySession,
                protectRuleEnv,
                routeExpirationDays,
                remediationPolicies,
                compliancePolicies,
                importance,
                customMetadataFields,
                customMetadataSettings,
                routeCoverageAbsolutePolicy
              }
            }) => {
              return (
                <OrganizationSettingsMutation>
                  {(updateSettings) => {
                    return children({
                      organizationID: organizationUuid,
                      numberOfLicensesUsed,
                      numberOfLicensesAvailable,
                      availableCompliancePolicies,
                      availableRemediationPolicies,
                      autoLicense,
                      filterAppMostRecentSession,
                      preventOnboardingFailingApplications,
                      preventOnboardingFailingApplicationsBySession,
                      protectRuleEnv,
                      routeExpirationDays,
                      remediationPolicies,
                      compliancePolicies,
                      importance,
                      customMetadataFields,
                      customMetadataSettings,
                      updateSettings,
                      routeCoverageAbsolutePolicy
                    })
                  }}
                </OrganizationSettingsMutation>
              )
            }}
          </OrganizationSettingsQuery>
        )
      }}
    </OrganizationQuery>
  )
}
